import { render, staticRenderFns } from "./SalaryAdvance.vue?vue&type=template&id=7120ba6b&"
import script from "./SalaryAdvance.vue?vue&type=script&lang=js&"
export * from "./SalaryAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports